/**
 * How a duration is written, everywhere the performance console writes one.
 *
 * Shared rather than owned by a chart because a page where the same 1,500 ms
 * reads as "1.50 s" in one panel and "1500 ms" in another is a page whose
 * numbers cannot be compared.
 *//** Milliseconds at a readable precision: fast readings keep their decimals. */export function formatMs(milliseconds){const duration=splitMs(milliseconds);return duration.unit===""?duration.value:"".concat(duration.value," ").concat(duration.unit);}/**
 * A duration split into its number and its unit.
 *
 * Split because they are not equally important: the figure is what a reader is
 * comparing across a row, and the unit is the same on every cell of the table.
 * Rendering them apart lets the number carry the weight and the unit recede.
 */export function splitMs(milliseconds){if(milliseconds==null){return{value:"—",unit:""};}if(milliseconds>=1000){return{value:(milliseconds/1000).toFixed(2),unit:"s"};}if(milliseconds>=10){return{value:String(Math.round(milliseconds)),unit:"ms"};}return{value:milliseconds.toFixed(2),unit:"ms"};}/**
 * The durations of the measurements that completed, in the order they arrived.
 *
 * The single definition of "completed", so any two charts drawn from the same
 * window are drawn from the same set.
 */export function completedDurationsMs(records){const durations=[];for(const record of records){// A measurement that never ended has no duration — it does not have a
// zero one, which is why this is a null check rather than a truthiness
// test. A call that really did complete in under half a millisecond
// rounds to zero, and belongs in the distribution like any other.
if(record.durationMs!=null){durations.push(record.durationMs);}}return durations;}